export const TriggerBonusAction = {
    getTriggerBonusLoading: "trigger-bonus:loading",
    getTriggerBonusLoaded: "trigger-bonus:loaded",
    getTriggerBonusError: "trigger-bonus:error",
    getTriggerBonusSuccess: "trigger-bonus:success",
    getTriggerBonusFromCache: "trigger-bonus:from-cache",
    sendTriggerBonusLoading: "trigger-bonus:send-loading",
    sendTriggerBonusLoaded: "trigger-bonus:send-loaded",
    sendTriggerBonusError: "trigger-bonus:send-error",
    sendTriggerBonusSuccess: "trigger-bonus:send-success",
}

export function getTriggerBonusSuccess(data) {
    return {
        type: TriggerBonusAction.getTriggerBonusSuccess,
        payload: data,
    }
}

export function getTriggerBonusFromCache(data) {
    return {
        type: TriggerBonusAction.getTriggerBonusFromCache,
        payload: data,
    }
}

export function getTriggerBonusLoading() {
    return {
        type: TriggerBonusAction.getTriggerBonusLoading,
        payload: true,
    }
}

export function getTriggerBonusLoaded() {
    return {
        type: TriggerBonusAction.getTriggerBonusLoaded,
        payload: true,
    }
}

export function getTriggerBonusError(data) {
    return {
        type: TriggerBonusAction.getTriggerBonusError,
        payload: data,
    }
}

export function sendTriggerBonusSuccess(data) {
    return {
        type: TriggerBonusAction.sendTriggerBonusSuccess,
        payload: data,
    }
}

export function sendTriggerBonusLoading() {
    return {
        type: TriggerBonusAction.sendTriggerBonusLoading,
        payload: true,
    }
}

export function sendTriggerBonusLoaded() {
    return {
        type: TriggerBonusAction.sendTriggerBonusLoaded,
        payload: true,
    }
}

export function sendTriggerBonusError(data) {
    return {
        type: TriggerBonusAction.sendTriggerBonusError,
        payload: data,
    }
}
